import { type NCWBalanceType } from '@capsicum/socios-core';

import { useConvertToFiatAndFormat } from './useConvertToFiatAndFormat';

/**
 * Provides conversion CHZ to whichever fiat currency is in use. The output
 * value is formatted. Returns undefined if any data is missing or NaN
 * Call it like this: useConvertChilizToFiatAndFormat(useNCWBalance())
 * */
export const useConvertChilizToFiatAndFormat = (ncwBalance: NCWBalanceType) => {
	const convertToFiatAndFormat = useConvertToFiatAndFormat();
	const { chilizBalance: { conversionToFiat: chilizToFiatConversionData } = {} } = ncwBalance;

	return (chilizAmount: number | string | undefined) =>
		convertToFiatAndFormat({
			...chilizToFiatConversionData,
			assetAmount: chilizAmount
		});
};
